import React, { useState, useEffect, useRef, Suspense, lazy } from "react"
import MesaiView from "views/Pages/Mesas/Plantillas/indice"
import MesasView from "views/Pages/Mesas"
// PERF: svgoptio.js pesa ~3MB (todos los mapas de venues); se carga solo cuando este modal
// realmente se abre, en vez de ir en el bundle inicial de la tienda publica.
const SVGView = lazy(() => import("views/Pages/Svgviewa/svgoptio.js"));
import { TiendaIten, getVerTienda, EliminarByStora, EliminarsilladeMesa } from "utils/CarritoLocalStorang";
import { Modal } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { filtrarlocali, settypo } from "StoreRedux/Slice/mapaLocalSlice";
import { addSillas, deleteSillas, clearSillas, deleteMesa } from "StoreRedux/Slice/sillasSlice"
import { EliminarSillas, AgregarAsiento, VerSillaslist, TotalSelecion } from "utils/CarritoLocalStorang"
import SweetAlert from "react-bootstrap-sweetalert";
import "./localidas.css"
import { getDatosUsuariosLocalStorag } from "utils/DatosUsuarioLocalStorag";
import { seleccionmapa } from "utils/constantes";
import { enviasilla } from "utils/Querypanelsigui";
import { quitarsilla } from "utils/Querypanelsigui";
import { correlativosadd } from "utils/Querypanelsigui";
import moment from "moment";
import { Verificalocalidad } from "utils/CarritoLocalStorang";
import { setModal } from "StoreRedux/Slice/SuscritorSlice";
import { localidaandespacio } from "utils/Querypanel";
import { resolverEspacioLocalidad } from "utils/localidadNavegacion";
import { setToastes } from "StoreRedux/Slice/ToastSlice";
import { factorDeLocalidad, mensajeParesX2 } from "utils/paresX2";
import { updateboletos } from "StoreRedux/Slice/SuscritorSlice";
import { clienteInfo } from "utils/DatosUsuarioLocalStorag";
import { bancos } from "utils/Imgenesutils";
import { Triangle } from "react-loader-spinner";
import { setSpinersli } from "StoreRedux/Slice/SuscritorSlice";
import { logWithCallback } from "utilsstile.js/style";
import axios from "axios";
let { atencion } = bancos

const PALETA_FONDO_SEC = ['#fce8e8', '#e8f0fc', '#e8fce8', '#fdf5e8', '#f3e8fc', '#e8fcf8']

const LocalidadmapViews = (props) => {
    const { intervalo, intervalolista, precios } = props
    var mapath = useSelector((state) => state.mapaLocalSlice)
    let nombre = JSON.parse(sessionStorage.getItem(seleccionmapa))
    const usedispatch = useDispatch()
    const [detalle, setDetalle] = useState([])
    const [cambiandoLocalidad, setCambiandoLocalidad] = useState(false)
    const [mostrarAlertaPromocion, setMostrarAlertaPromocion] = useState(false)
    const [secciones, setSecciones] = useState({})
    const [orden, setOrden] = useState({})
    const [alineacionFilas, setAlineacionFilas] = useState({})
    const [ordenSillasFilas, setOrdenSillasFilas] = useState({})
    const [zoomMesas, setZoomMesas] = useState(1)
    function ordenarMesas(mesas, ordenMap) {
        return mesas
            .map((m, i) => ({ m, i }))
            .sort((a, b) => {
                const oa = ordenMap[a.m.mesa] ?? a.i
                const ob = ordenMap[b.m.mesa] ?? b.i
                return oa - ob
            })
            .map(x => x.m)
    }

    const seleccion = useSelector((state) => state.sillasSlice.sillasSelecionadas.filter((e) => e.localidad == mapath.precio.localidad))
    const modalshow = useSelector((state) => state.SuscritorSlice.modal)
    const spinervi = useSelector((state) => state.SuscritorSlice.spiner)
    const [alert, setAlert] = useState(null);
    let sleccionlocalidad = useSelector((state) => state.SuscritorSlice.boletos)

    const obtenerFactorCorrelativo = () => {
        const raw = Number(
            mapath?.precio?.correlativo_factor_boletos ||
            mapath?.precio?.factor_boletos ||
            (String(mapath?.precio?.correlativo_doble_boleto).toLowerCase() === "true" ? 2 : 1)
        )
        const entero = Number.isFinite(raw) ? Math.floor(raw) : 1
        if (entero < 1) return 1
        if (entero > 10) return 10
        return entero
    }

    const obtenerModalidadCorrelativa = () => {
        // Opcion de compra elegida (promocion de la localidad)
        if (mapath?.precio?.modalidad_codigo) return mapath.precio.modalidad_codigo
        const factor = obtenerFactorCorrelativo()
        return factor > 1 ? "DOUBLE" : "SIMPLE"
    }

    const eliminarmesas = (M, C) => {
        let nombres = JSON.parse(sessionStorage.getItem(seleccionmapa))
        let user = getDatosUsuariosLocalStorag()
        let nuevo = []
        for (let i = 1; i < parseInt(C) + 1; i++) {
            let valid = seleccion.some(e => e.seleccionmapa == nombre.localidad + "-" + M + "-s-" + i && e.estado.toLowerCase() == "seleccionado")
            if (valid) {
                nuevo.push({ id: nombres.idcolor, silla: M + "-s-" + i })
            }
        }
        nuevo.length > 0 ? nuevo.map((elm, index) => {
            setTimeout(() => {
                quitarsilla({ "array": [{ estado: "disponible", "id": elm.id, "silla": elm.silla, "cedula": user.cedula }] }).then(ouput => {
                    usedispatch(deleteSillas({ "localidad": nombre.localidad, "fila": elm.silla.split("-")[0], "silla": elm.silla, "estado": "seleccionado" }))
                    EliminarsilladeMesa({ localidad: nombre.localidad + "-" + elm.silla })
                }).catch(err => logWithCallback(err))


            }, 15 * index)

        }) : ''
        hideAlert()
    }
    function restaprecio() {
        let user = getDatosUsuariosLocalStorag()
        const factor = obtenerFactorCorrelativo()
        const modalidadCodigo = obtenerModalidadCorrelativa()
        let producto = {
            cantidad: -factor,
            localidad: mapath.precio.localidad,
            localidaEspacio: {
                ...mapath.precio,
                factor_boletos: factor,
                cantidad_paquetes: 1,
                modalidad_codigo: modalidadCodigo,
            },
            id: mapath.precio.idcolor,
            fila: 0,
            valor: mapath.precio.precio_normal,
            nombreConcierto: sessionStorage.getItem("consierto"),
            factor_boletos: factor,
            cantidad_paquetes: 1,
            modalidad_codigo: modalidadCodigo,
        }
        setDisable(true)

        usedispatch(setSpinersli({ spiner: false }))
        getVerTienda().find(e => e.localidaEspacio["idcolor"] == mapath.precio.idcolor) == undefined ? '' :
            correlativosadd({
                "id": mapath.precio.idcolor,
                "estado": "reservado",
                "cedula": user.cedula,
                "mas": "menos",
                random: sessionStorage.getItem("random"),
                "cantidad": factor
            }).then(oupt => {
                if (oupt.success) {
                    let array = oupt.idLocalidadesSillas
                    sessionStorage.setItem("sillascorre", JSON.stringify([...array]))

                    getVerTienda().find(e => e.localidaEspacio["idcolor"] == mapath.precio.idcolor) == undefined ? '' : TiendaIten({ ...producto, protocol: getVerTienda().find(e => e.localidaEspacio["idcolor"] == mapath.precio.idcolor).protocol, tipo: "correlativo" })
                    setDetalle(getVerTienda().filter(e => e.id == mapath.precio.idcolor))
                    setDisable(false)
                    setTimeout(function () {

                        usedispatch(setSpinersli({ spiner: true }))
                    }, 0)
                    return
                }
                usedispatch(setSpinersli({ spiner: true }))
            }).catch(err => {
                setDisable(false)
                logWithCallback(err)
            })
    }
    const [disable, setDisable] = useState(false)
    function agregar() {
        let user = getDatosUsuariosLocalStorag()
        const factor = obtenerFactorCorrelativo()
        const modalidadCodigo = obtenerModalidadCorrelativa()

        if (sleccionlocalidad.disponibles == 0) {
            usedispatch(setToastes({
                show: true,
                message: "No hay más disponibilida en la localidad",
                color: 'bg-danger',
                estado: "Localidad llena"
            }))
            return
        }
        if ((sleccionlocalidad.pagados + TotalSelecion()) == 100) {
            succesLimit()
            return
        }
        let protoco = moment().format("YYYYMMDDHHMMSS")
        let producto = {
            cantidad: factor,
            localidad: mapath.precio.localidad,
            localidaEspacio: {
                ...mapath.precio,
                factor_boletos: factor,
                cantidad_paquetes: 1,
                modalidad_codigo: modalidadCodigo,
            },
            id: mapath.precio.idcolor,
            tipo: "correlativo",
            fila: 0,
            discapacidad: mapath.precio.precio_discapacidad,
            valor: mapath.precio.precio_normal,
            nombreConcierto: sessionStorage.getItem("consierto") ? sessionStorage.getItem("consierto") : '',
            factor_boletos: factor,
            cantidad_paquetes: 1,
            modalidad_codigo: modalidadCodigo,
        }

        if (TotalSelecion() < 100) {
            setDisable(true)
            usedispatch(setSpinersli({ spiner: false }))

            window.gtag("event", "add_to_cart", {
                currency: "USD",
                value: mapath.precio.precio_normal,
                items: [
                    {
                        item_id: mapath.precio.id,
                        item_name: mapath.precio.localidad,
                        affiliation: "Mas",
                        index: 0,
                        item_brand: "Google",
                        price: mapath.precio.precio_normal,
                        "cantidad": factor
                    }
                ]
            });
            correlativosadd({
                "id": mapath.precio.idcolor,
                "estado": "reservado",
                "cedula": user.cedula,
                "mas": "mas",
                random: sessionStorage.getItem("random"),
                "cantidad": factor
            }).then(oupt => {
                if (oupt.success) {


                    let array = oupt.idLocalidadesSillas

                    sessionStorage.setItem("sillascorre", JSON.stringify([...array]))
                    getVerTienda().find(e => e.localidaEspacio["idcolor"] == mapath.precio.idcolor) == undefined ? TiendaIten({ ...producto, "protocol": protoco, tipo: "correlativo" }) : TiendaIten({ ...producto, protocol: getVerTienda().find(e => e.localidaEspacio["idcolor"] == mapath.precio.idcolor).protocol, tipo: "correlativo" })
                    setDetalle(getVerTienda().filter(e => e.id == mapath.precio.idcolor))
                    setTimeout(function () {

                        setDisable(false)
                        usedispatch(setSpinersli({ spiner: true }))



                    }, 0)

                    return
                }
                usedispatch(setSpinersli({ spiner: true }))

            }

            ).catch(erro => {
                setDisable(false)
            })
        }
        else {
            setDisable(false)
            succesLimit()
        }
    }
    function Eliminar(e) {
        EliminarByStora(e.localidad)
        setDetalle([])
    }

    const succesLimit = () => {
        setAlert(
            <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}

                closeOnClickOutside={false}
                showCancel={false}
                showConfirm={false}
                closeAnim={{ name: 'hideSweetAlert', duration: 500 }}
            >
                <div>
                    <div className='col-12 pb-3'>
                        <img src={atencion} className="img-fluid"
                            style={{
                                height: 100
                            }}
                        ></img>
                    </div>
                    <h5>Has alcanzado la cantidad límite de entradas</h5>
                    Deseas continuar editando la selección
                    <div className='d-flex  justify-content-around py-4 px-2'>
                        <div>
                            <button className='btn btn-outline-danger  rounded-6' onClick={() => cerrar()}>
                                <span style={{
                                    fontWeight: "bold"
                                }}>Ir al carrito</span>
                            </button>
                        </div>
                        <div>
                            <button className=' btn btn-warning rounded-5' onClick={() => hideAlert()} >
                                <span style={{
                                    fontWeight: "bold"
                                }}> Si, Continuar</span>
                            </button>
                        </div>

                    </div>
                </div>
            </SweetAlert>
        )
    }

    function Agregarsilla(e) {
        if (String(e.estado.toLowerCase()) == "ocupado") return
        let info = JSON.parse(sessionStorage.getItem("DatoCliente")) || sessionStorage.getItem("random")
        let user = getDatosUsuariosLocalStorag()
        const cedulaPayload = user?.cedula || info?.cedula || null
        if (!cedulaPayload) {
            usedispatch(setToastes({
                show: true,
                message: "Seleccione un cliente con cédula antes de elegir sillas.",
                color: 'bg-danger',
                estado: "Cliente incompleto"
            }))
            return
        }
        const seatId = e.idsilla ?? e.id ?? e.id_silla ?? null
        if (!seatId) {
            logWithCallback({
                modulo: "Modallocalida.Agregarsilla.sinId",
                localidad: nombre?.localidad,
                silla: e.silla,
                estado: e.estado,
                payload: e,
            }, "warning")
            usedispatch(setToastes({
                show: true,
                message: "No se pudo seleccionar la silla porque no tiene identificador.",
                color: 'bg-danger',
                estado: "ID de silla faltante"
            }))
            return
        }
        let variant = document.getElementById(String(seatId))
        if (!variant) {
            usedispatch(setToastes({
                show: true,
                message: "No se pudo ubicar la silla seleccionada en el mapa.",
                color: 'bg-warning',
                estado: "Silla no encontrada"
            }))
            return
        }
        variant.classList.remove('disponible')
        variant.classList.add('seleccionado')
        const isOwnSeat = e.cedula == cedulaPayload ||
            seleccion.some(s => s.seleccionmapa === nombre?.localidad + "-" + e.silla)
        if (e.estado.toLowerCase() != "disponible" && !isOwnSeat) {
            return
        }
        const localidadId = mapath.precio.idcolor ?? mapath.precio.id_localidad ?? nombre?.idcolor ?? nombre?.id_localidad ?? mapath.pathmap[0]?.id
        if (!localidadId) {
            logWithCallback({
                modulo: "Modallocalida.Agregarsilla.sinLocalidadId",
                precio: mapath.precio,
                seleccionmapa: nombre,
                pathmap: mapath.pathmap,
            }, "warning")
            usedispatch(setToastes({
                show: true,
                message: "No se pudo seleccionar la silla porque falta el id de localidad.",
                color: 'bg-danger',
                estado: "ID de localidad faltante"
            }))
            return
        }
        let datos = {
            "cedula": cedulaPayload,
            "estado": "disponible",
            "id": localidadId,
            "cantidad": 1,
            "mas": "mas",
            random: sessionStorage.getItem("random"),
            "mesa": [
                {
                    id_silla: seatId,
                    id: localidadId,
                    "cedula": cedulaPayload,
                    random: sessionStorage.getItem("random"),
                    estado: "",
                    ...e
                }
            ]
        }
        usedispatch(setSpinersli({ spiner: false }))
        correlativosadd(datos).then(ou => {
            if (ou.success) {
                ou.insert.map((g => {
                    let asiento = e
                    const localidadInfo = {
                        ...nombre,
                        localidad: nombre?.localidad || mapath?.precio?.localidad,
                        idcolor: nombre?.idcolor || mapath?.precio?.idcolor || mapath?.precio?.id_localidad,
                        id_localidad: nombre?.id_localidad || mapath?.precio?.id_localidad || mapath?.precio?.idcolor,
                        precio_normal: nombre?.precio_normal || mapath?.precio?.precio_normal,
                        precio_discapacidad: nombre?.precio_discapacidad || mapath?.precio?.precio_discapacidad,
                        typo: "fila",
                    }
                    AgregarAsiento({
                        "localidad": localidadInfo.localidad, "localidaEspacio": localidadInfo, "nombreConcierto": sessionStorage.getItem("consierto"), "valor": localidadInfo.precio_normal,
                        seleccionmapa: localidadInfo.localidad + "-" + asiento.silla,
                        "fila": asiento.silla.split("-")[0], "silla": asiento.silla, "estado": "seleccionado", "ids": seatId, "cedula": cedulaPayload
                    })
                    usedispatch(addSillas({
                        "localidad": localidadInfo.localidad, "localidaEspacio": localidadInfo,
                        "nombreConcierto": sessionStorage.getItem("consierto"), "valor": localidadInfo.precio_normal,
                        seleccionmapa: localidadInfo.localidad + "-" + asiento.silla, "fila": asiento.silla.split("-")[0],
                        "silla": asiento.silla, "estado": "seleccionado"
                    }))
                    let nombres = JSON.parse(sessionStorage.getItem(seleccionmapa))
                    setAlert(
                        <SweetAlert
                            success
                            style={{ display: "block", marginTop: "-100px" }}
                            title="Se agrego"
                            onConfirm={() => hideAlert()}
                            onCancel={() => cerrar()}
                            confirmBtnBsStyle="success"
                            cancelBtnBsStyle="danger"
                            confirmBtnText="Seguir Agregando"
                            cancelBtnText="Ir al carrito"
                            closeOnClickOutside={false}
                            closeAnim={{ name: 'hideSweetAlert', duration: 500 }}
                            showCancel
                        >
                            <div className="d-flex flex-row justify-content-center text-center">
                                <div className="d-flex">
                                    <h4 style={{ fontSize: '0.9em' }} >
                                        De la Localidad {nombres.localidad} En la Fila:  {e.silla.replace("-", " ").split(" ")[0]} la Silla #{e.silla.split("-")[1]}  </h4>
                                </div>
                            </div>
                        </SweetAlert>
                    )
                }))
                ou.update.map((g => {
                    let asiento = e
                    variant.classList.remove('seleccionado')
                    variant.classList.add('disponible')
                    usedispatch(deleteSillas({
                        "localidad": nombre.localidad,
                        "fila": asiento.silla.split("-")[0],
                        "silla": asiento.silla,
                        "estado": "seleccionado"
                    }))
                    EliminarsilladeMesa({ localidad: nombre.localidad + "-" + asiento.silla })
                    let nombres = JSON.parse(sessionStorage.getItem(seleccionmapa))
                    setAlert(
                        <SweetAlert
                            success
                            style={{ display: "block", marginTop: "-100px" }}
                            title="Se elimino"
                            onConfirm={() => hideAlert()}
                            onCancel={() => cerrar()}
                            confirmBtnBsStyle="success"
                            cancelBtnBsStyle="danger"
                            confirmBtnText="Seguir Agregando"
                            cancelBtnText="Ir al carrito"
                            closeOnClickOutside={false}
                            closeAnim={{ name: 'hideSweetAlert', duration: 500 }}
                            showCancel
                        >
                            <div className="d-flex flex-row justify-content-center text-center">
                                <div className="d-flex">
                                    <h4 style={{ fontSize: '0.9em' }} >
                                        De la Localidad {nombres.localidad} En la Fila:  {e.silla.replace("-", " ").split(" ")[0]} la Silla #{e.silla.split("-")[1]}  </h4>
                                </div>
                            </div>
                        </SweetAlert>
                    )
                }))
                setTimeout(function () {

                    usedispatch(setSpinersli({ spiner: true }))
                }, 0)
                return
            }
            usedispatch(setSpinersli({ spiner: true }))

        }).catch(err => {
            logWithCallback(err)
        })
    }
    const hideAlert = () => {
        setAlert(null);
    }
    const sillasetado = (d) => {
        const user = getDatosUsuariosLocalStorag()
        let nombres = JSON.parse(sessionStorage.getItem(seleccionmapa))
        if (d.cedula != undefined) {
            if (d.estado.toLowerCase() == "ocupado") return d.estado.toLowerCase()
            if (user.cedula == d.cedula) return "seleccionado  " + nombres.idcolor + "silla"
            else
                return d.estado.toLowerCase() == "seleccionado" ? "reservado" : d.estado.toLowerCase()
        }
        else return d.estado.toLowerCase()
    }
    useEffect(() => {
        let disponible = document.querySelectorAll("div.disponible, a.disponible")
        let reservado = document.querySelectorAll("div.reservado, a.reservado")
        let seleccion = document.querySelectorAll("div.seleccionado, a.seleccionado")
        let ocupado = document.querySelectorAll("div.ocupado, a.ocupado")
        let apartado = document.querySelectorAll("div.apartado, a.apartado")
        $("#disponible").text(disponible.length)
        $("#ocupado").text(Number(ocupado.length) + Number(apartado.length))
        $("#reservado").text(reservado.length)
        $("#seleccionado").text(seleccion.length)
    })

    function Cargarlisat() {
        clearInterval(intervalolista.current)
        const user = getDatosUsuariosLocalStorag()

        intervalolista.current = setInterval(function () {
            modalshow.nombre == "Modallocalida" ? '' : clearInterval(intervalolista.current);
            localidaandespacio(mapath.precio.espacio, mapath.precio.idcolor).then(ouput => {

                if (ouput.data.find(e => e.typo == "fila")) {
                    let nuevoObjeto = []
                    ouput.data.forEach(x => {
                        if (!nuevoObjeto.some(e => e.fila == x.fila)) {
                            nuevoObjeto.push({ fila: x.fila, asientos: [{ silla: x.silla, estado: x.estado, idsilla: x.id ?? x.idsilla ?? x.id_silla ?? null, cedula: x.cedula }] })
                        }
                        else {
                            let indixe = nuevoObjeto.findIndex(e => e.fila == x.fila)
                            nuevoObjeto[indixe].asientos.push({
                                silla: x.silla, estado: x.estado, idsilla: x.id ?? x.idsilla ?? x.id_silla ?? null, cedula: x.cedula
                            })
                        }
                    })
                    mapath.precio.typo == "fila" ? usedispatch(filtrarlocali(nuevoObjeto)) : ''
                  
                } else if (ouput.data.find(e => e.typo == "mesa")) {
                    let nuevoObjeto = []
                    ouput.data.forEach(x => {
                        if (!nuevoObjeto.some(e => e.fila == x.fila)) {
                            nuevoObjeto.push({ fila: x.fila, Mesas: [] })
                        }
                    })
                    nuevoObjeto.length > 0 ? ouput.data.forEach(x => {
                        let index = nuevoObjeto.findIndex(z => z.fila == x.fila)
                        if (nuevoObjeto[index].Mesas.findIndex(z => z.mesa == x.mesa) == -1) {
                            nuevoObjeto[index].Mesas.push({ mesa: x.mesa, asientos: [] })
                        }
                    }) : ''
                    nuevoObjeto.length > 0 ? ouput.data.forEach(x => {
                        let index = nuevoObjeto.findIndex(z => z.fila == x.fila)
                        let sillas = nuevoObjeto[index].Mesas.findIndex(y => y.mesa == x.mesa)
                        nuevoObjeto[index].Mesas[sillas].asientos.push({
                            silla: x.silla, estado: x.estado, idsilla: x.id ?? x.idsilla ?? x.id_silla ?? null, cedula: x.cedula
                        })
                    })
                        : ''
                    mapath.precio.typo == "mesa" ? usedispatch(filtrarlocali(nuevoObjeto)) : ''
                }
                else if (ouput.data.some(e => e.typo == "correlativo")) {
                   
                    mapath.precio.typo == "correlativo" ? usedispatch(filtrarlocali(ouput.data.filter(e => e.estado == null))) : ''
                    usedispatch(updateboletos({
                        disponibles: ouput.data.filter(e => e.estado == null || e.estado.toLowerCase() == "disponible").length,
                        proceso: ouput.data.filter(e => e.estado.toLowerCase() == "reservado" && e.cedula == user.cedula).length,
                        pagados: sleccionlocalidad.pagados,
                        inpagos: sleccionlocalidad.inpagos
                    }))
                }
            }).catch(err => {
               logWithCallback(err)
            })
        }, 4000)
        mapath.precio.typo == "correlativo" ? clearInterval(intervalolista.current) : ""
    }
    useEffect(() => {
        let user = getDatosUsuariosLocalStorag()

        // Pinta la zona de la localidad en el mapa. Se busca por id (no con el selector de jQuery): un
        // id con caracteres raros ya no puede romper la pagina, y si la localidad no tiene zona en el mapa
        // (esta fuera del mapa) simplemente no se pinta nada.
        const pintarZona = (path, fill) => {
            try {
                const zona = document.getElementById("mapas" + path)
                if (!zona) return
                zona.setAttribute("fill", fill)
                zona.removeAttribute("class")
            } catch (_e) { /* zona sin pintar, la compra sigue */ }
        }
        mapath.localidadespecica != undefined && mapath.pathmap.length > 0 ? mapath.pathmap.forEach((e) => {
            pintarZona(e.path, sessionStorage.getItem("eventoid") != "YZPQQ3" ? e.fill : "red")
        }) : ''
        let producto = {
            localidad: mapath.precio.localidad,
            localidaEspacio: mapath.precio,
            id: mapath.precio.idcolor,
            fila: 0, tipo: "correlativo",
            discapacidad: mapath.precio.precio_discapacidad,
            valor: mapath.precio.precio_normal,
            nombreConcierto: sessionStorage.getItem("consierto") ? sessionStorage.getItem("consierto") : '',
        }
        let cantidad = mapath.localidadespecica.info != undefined ? mapath.localidadespecica.info.length > 0 ? mapath.localidadespecica.info.filter(ced => ced.cedula == user.cedula) : [] : []
        mapath.localidadespecica.info != undefined ? mapath.localidadespecica.info.length > 0 ? cantidad.length > 0 ? setDetalle(Verificalocalidad(producto, cantidad).filter((e) => e.id == mapath.precio["idcolor"])) : '' : '' : ''
        getVerTienda().filter((e) => e.id == mapath.precio.idcolor).length > 0 ? setDetalle(getVerTienda().filter((e) => e.id == mapath.precio.idcolor)) : setDetalle([])
        Cargarlisat()
        window.gtag('event', mapath.precio.localidad + "" + mapath.precio.codigoEvento, {
            'event_category': 'Modal Localidad',
            'event_label': mapath.precio.codigoEvento,
            'value': mapath.precio.precio_normal

        });
    }, [modalshow.nombre == "Modallocalida" ? true : false, mapath.precio.idcolor])
    
    useEffect(() => {
        const modalAbierto = modalshow?.nombre == "Modallocalida"
        const tienePromocion = mapath?.precio?.mensaje_promocion && String(mapath.precio.mensaje_promocion).trim().length > 0

        if (modalAbierto && tienePromocion) {
            setMostrarAlertaPromocion(true)
            return
        }

        if (!modalAbierto || !tienePromocion) {
            setMostrarAlertaPromocion(false)
        }
    }, [modalshow?.nombre, mapath?.precio?.idcolor, mapath?.precio?.mensaje_promocion, mapath?.precio?.correlativo_factor_boletos])

    useEffect(() => {
        const idLocalidad = mapath?.precio?.idcolor
        if (!idLocalidad || modalshow?.nombre !== "Modallocalida") return
        axios.get(
            `https://api.t-ickets.com/ms_login/api/v1/listar_localidades/${idLocalidad}`,
            { headers: { 'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ==' } }
        ).then(res => {
            try {
                const row = Array.isArray(res.data?.data) ? res.data.data[0] : res.data?.data
                const ma = JSON.parse(row?.mesas_array || '{}')
                setSecciones(ma.secciones || {})
                setOrden(ma.orden || {})
                setAlineacionFilas(ma.alineacion || {})
                setOrdenSillasFilas(ma.ordenSillas || {})
            } catch (_) { setSecciones({}); setOrden({}); setAlineacionFilas({}); setOrdenSillasFilas({}) }
        }).catch(() => { setSecciones({}); setOrden({}); setAlineacionFilas({}); setOrdenSillasFilas({}) })
    }, [modalshow?.nombre, mapath?.precio?.idcolor])

    // Lista de localidades en el mismo orden que se muestra en "SELECCIONE LA
    // LOCALIDAD EN EL MAPA O EN EL NOMBRE" (ModalCarritov), para poder pasar
    // de una a otra en ese mismo orden con los botones siguiente/anterior.
    function listaLocalidadesOrdenada() {
        return (precios?.precios || [])
            .filter(e => e.habilitar_cortesia != 0)
            .sort((a, b) => a.precio_normal - b.precio_normal)
    }

    function agruparPorTipo(data) {
        if (data.some(e => e.typo == "fila")) {
            let nuevoObjeto = []
            data.forEach(x => {
                if (!nuevoObjeto.some(e => e.fila == x.fila)) {
                    nuevoObjeto.push({ fila: x.fila, asientos: [{ silla: x.silla, estado: x.estado, idsilla: x.id ?? x.idsilla ?? x.id_silla ?? null, cedula: x.cedula }] })
                } else {
                    let indixe = nuevoObjeto.findIndex(e => e.fila == x.fila)
                    nuevoObjeto[indixe].asientos.push({ silla: x.silla, estado: x.estado, idsilla: x.id ?? x.idsilla ?? x.id_silla ?? null, cedula: x.cedula })
                }
            })
            return { typo: 'fila', agrupado: nuevoObjeto }
        }
        if (data.some(e => e.typo == "mesa")) {
            let nuevoObjeto = []
            data.forEach(x => {
                if (!nuevoObjeto.some(e => e.fila == x.fila)) nuevoObjeto.push({ fila: x.fila, Mesas: [] })
            })
            data.forEach(x => {
                let index = nuevoObjeto.findIndex(z => z.fila == x.fila)
                if (nuevoObjeto[index].Mesas.findIndex(z => z.mesa == x.mesa) == -1) {
                    nuevoObjeto[index].Mesas.push({ mesa: x.mesa, asientos: [] })
                }
            })
            data.forEach(x => {
                let index = nuevoObjeto.findIndex(z => z.fila == x.fila)
                let sillas = nuevoObjeto[index].Mesas.findIndex(y => y.mesa == x.mesa)
                nuevoObjeto[index].Mesas[sillas].asientos.push({ silla: x.silla, estado: x.estado, idsilla: x.id ?? x.idsilla ?? x.id_silla ?? null, cedula: x.cedula })
            })
            return { typo: 'mesa', agrupado: nuevoObjeto }
        }
        return { typo: 'correlativo', agrupado: data.filter(e => e.estado == null) }
    }

    async function irALocalidad(direccion) {
        try {
            const lista = listaLocalidadesOrdenada()
            const indiceActual = lista.findIndex(e => e.idcolor == mapath.precio.idcolor || e.id == mapath.precio.idcolor)
            const nuevoIndice = indiceActual + direccion
            if (indiceActual == -1 || nuevoIndice < 0 || nuevoIndice >= lista.length) return
            const nuevaLocalidad = lista[nuevoIndice]
            const espacioDestino = resolverEspacioLocalidad(nuevaLocalidad, mapath?.precio?.espacio)
            if (!espacioDestino || !nuevaLocalidad?.idcolor) {
                usedispatch(setToastes({ show: true, message: "No se encontró la configuración completa de la localidad", color: 'bg-danger', estado: "Intenta nuevamente" }))
                return
            }
            setCambiandoLocalidad(true)
            const ouput = await localidaandespacio(espacioDestino, nuevaLocalidad.idcolor)
            const { typo, agrupado } = agruparPorTipo(ouput.data)
            const localidadSeleccionada = { ...nuevaLocalidad, typo }
            usedispatch(filtrarlocali(agrupado))
            usedispatch(settypo({ nombre: mapath.nombre, typo, precio: localidadSeleccionada }))
            sessionStorage.seleccionmapa = JSON.stringify(localidadSeleccionada)
        } catch (error) {
            logWithCallback(error)
            usedispatch(setToastes({ show: true, message: "No se pudo cambiar de localidad", color: 'bg-danger', estado: "Error" }))
        } finally {
            setCambiandoLocalidad(false)
        }
    }

    function cerrar() {
        // Numerada x2: no se sale con una mesa/fila a medias (se cobra por par y el backend la rechazaria)
        const avisoX2 = mensajeParesX2(seleccion)
        if (avisoX2) {
            usedispatch(setToastes({ show: true, message: avisoX2, color: 'bg-warning', estado: 'Sillas de a pares' }))
            return
        }
        clearInterval(intervalolista.current)
        usedispatch(setModal({ nombre: '', estado: '' }))
        usedispatch(filtrarlocali([]))
        sessionStorage.removeItem(seleccionmapa)
        usedispatch(setModal({ nombre: 'ModalCarritov', estado: '' }))
        hideAlert()
        return
    }
    modalshow.nombre != "Modallocalida" ? clearInterval(intervalolista.current) : ''
    return (
        <>
            {alert}
            <Modal
                show={modalshow.nombre == "Modallocalida" ? true : false}
                size="lg"
                fullscreen={'md-down'}
                onHide={cerrar}
                centered
            >

                <Modal.Header className=" bg-dark  text-light py-4" style={{ position: "relative", zIndex: 10 }}>

                    <h5 className="modal-title text-center justify-content-center" style={{ fontWeight: "bold" }}>Tiempo restante de compra <span className="text-danger" >{intervalo} </span></h5>
                    <div className="pl-0" >
                        <button className="btn btn-outline-light" onClick={() => cerrar()} >
                            <i className="fa fa-arrow-left">  </i>
                            <span className="mx-1">Retroceder</span>
                        </button>
                        <button className=" btn  btn-danger mx-1" onClick={() => cerrar()} >
                            Continuar <i className="fa fa-shopping-cart">  </i>
                        </button>
                    </div>

                </Modal.Header>
                <Modal.Body className={mapath.precio.typo === "correlativo" ? " d-flex align-items-center mx-auto" : ""}>
                    {mapath.precio.typo !== "correlativo" && factorDeLocalidad(mapath.precio) > 1 ? (
                        <div className="alert alert-info py-2 text-center">
                            Localidad <b>x{factorDeLocalidad(mapath.precio)}</b>: elige las sillas de {factorDeLocalidad(mapath.precio)} en {factorDeLocalidad(mapath.precio)} en
                            la misma mesa. Pagas <b>${mapath.precio.precio_normal}</b> por cada {factorDeLocalidad(mapath.precio)} sillas.
                        </div>
                    ) : null}

                    {cambiandoLocalidad && (
                        <div style={{
                            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                            backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', flexDirection: 'column',
                            justifyContent: 'center', alignItems: 'center', zIndex: 2000
                        }}>
                            <Triangle height="80" width="80" color="#4fa94d" ariaLabel="cambio-localidad-loading" visible={true} />
                            <h4 className='text-light'>Cargando localidad...</h4>
                        </div>
                    )}
                    <div className='conatiner-fluid col-12'>
                        <div className="row  ">
                            <div className="col-12 d-flex  flex-column justify-content-center text-center" style={{ fontWeight: "bold" }}>
                                <h5 className="d-none">Libres: {sleccionlocalidad.disponibles}</h5>
                                <div className="d-flex justify-content-center align-items-center" style={{ gap: '10px' }}>
                                    <button type="button" className="btn btn-sm btn-outline-primary" title="Localidad anterior"
                                        disabled={cambiandoLocalidad}
                                        onClick={() => irALocalidad(-1)}>
                                        <i className="fa fa-chevron-left"></i>
                                    </button>
                                    <h5 style={{ fontWeight: "bold", margin: 0 }}>{mapath.precio.localidad}</h5>
                                    <button type="button" className="btn btn-sm btn-outline-primary" title="Siguiente localidad"
                                        disabled={cambiandoLocalidad}
                                        onClick={() => irALocalidad(1)}>
                                        <i className="fa fa-chevron-right"></i>
                                    </button>
                                </div>
                                <h6 className="px-1"
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: "0.8em"
                                    }}
                                >$ {mapath.precio.precio_tarjeta} </h6>
                            </div>
                            <div className="col-12 d-flex justify-content-center align-items-center" style={{ maxHeight: "200px", overflow: "hidden", pointerEvents: "none", position: "relative", zIndex: 0 }}>
                                {modalshow.nombre == "Modallocalida" ? mapath.nombre ? <Suspense fallback={null}><SVGView text={mapath.nombre} /></Suspense> : "" : ''}
                            </div> 
                            {mostrarAlertaPromocion && mapath?.precio?.mensaje_promocion ? (
                                <div className="col-12">
                                    <div className="alert alert-info alert-dismissible fade show mt-3 mx-2" role="alert" style={{ borderLeft: '4px solid #0d6efd' }}>
                                       
                                        <div className="mt-2" style={{ whiteSpace: 'pre-line' }}>
                                            {mapath.precio.mensaje_promocion}
                                        </div>
                                        {mapath?.precio?.cantidad_bloqueada ? (
                                            <div className="mt-2 p-2 rounded" style={{ background: '#e7f3ff' }}>
                                                <small><strong>⚠️ Cantidad restringida:</strong> Solo puedes comprar exactamente {obtenerFactorCorrelativo()} entradas en esta compra.</small>
                                            </div>
                                        ) : null}
                                        <button type="button" className="btn-close" onClick={() => setMostrarAlertaPromocion(false)}></button>
                                    </div>
                                </div>
                            ) : null}

                            {modalshow.nombre == "Modallocalida" && mapath.precio.typo != "correlativo" ?
                                <div className="col-12 d-flex  flex-wrap  ">
                                    <div className="d-flex  flex-row  p-2  align-items-center" >
                                        <div className="d-flex   mx-1 bg-success text-white justify-content-center align-items-center rounded-5  " style={{ height: '30px', width: '30px' }} >
                                            <div className="d-flex justify-content-center">
                                                <span style={{ fontSize: '0.7em' }} id="disponible" >  0   </span>
                                            </div>
                                        </div>
                                        <div className="d-flex flex-column justify-content-center align-items-center">
                                            <span>Disponibles.<span className="text-white">...</span></span>
                                        </div>
                                    </div>

                                    <div className="d-flex  flex-row  p-2  align-items-center" >
                                        <div className="d-flex   mx-1 bg-warning text-white justify-content-center align-items-center rounded-5  " style={{ height: '30px', width: '30px' }} >
                                            <div className="d-flex justify-content-center">
                                                <span style={{ fontSize: '0.7em', color: 'black' }} id="reservado">   0 </span>
                                            </div>
                                        </div>
                                        <span>En Proceso.</span>
                                    </div>

                                    <div className="d-flex  flex-row  p-2  align-items-center" >
                                        <div className="d-flex   mx-1 bg-secondary text-white justify-content-center align-items-center rounded-5  " style={{ height: '30px', width: '30px' }} >
                                            <div className="d-flex justify-content-center">
                                                <span style={{ fontSize: '0.7em' }} id="seleccionado" >   0 </span>
                                            </div>
                                        </div>
                                        <span>Seleccionado.</span>
                                    </div>

                                    <div className="d-flex flex-row p-2  align-items-center" >
                                        <div className="d-flex   mx-1 bg-danger text-white justify-content-center align-items-center rounded-5  " style={{ height: '30px', width: '30px' }} >
                                            <div className="d-flex justify-content-center">
                                                <span style={{ fontSize: '0.7em' }} id="ocupado" >   0 </span>
                                            </div>
                                        </div>
                                        <span>Ocupados.</span>
                                    </div>
                                </div> : ''}
                            <div className="col-12 pt-1">
                                {modalshow.nombre == "Modallocalida" && mapath.precio.typo == "fila" ? (() => {
                                    const totalFilas = mapath.localidadespecica.length
                                    return (
                                    <div className="section" style={{ maxHeight: '550px', minHeight: '250px', overflowY: 'auto', overflowX: 'auto' }}>
                                        <div className="row">
                                            {mapath.localidadespecica.length > 0 ?
                                                mapath.localidadespecica.map((e, i) => {
                                                    const sec = secciones[e.fila]
                                                    const seccionesUnicas = [...new Set(Object.values(secciones))].filter(Boolean)
                                                    const si = seccionesUnicas.indexOf(sec)
                                                    const PALETA_F = ['#fce8e8','#e8f0fc','#e8fce8','#fdf5e8','#f3e8fc','#e8fcf8']
                                                    const isFirst = i === 0 || secciones[mapath.localidadespecica[i - 1]?.fila] !== sec
                                                    const isLast  = i === totalFilas - 1 || secciones[mapath.localidadespecica[i + 1]?.fila] !== sec
                                                    return (
                                                        <div className='d-flex flex-row justify-content-around px-3 p-1' key={"lista" + i}
                                                            style={{
                                                                position: 'relative',
                                                                background:   sec ? PALETA_F[si % PALETA_F.length] : 'transparent',
                                                                borderLeft:   sec ? '3px solid #555' : 'none',
                                                                borderRight:  sec ? '3px solid #555' : 'none',
                                                                borderTop:    sec && isFirst ? '3px solid #555' : 'none',
                                                                borderBottom: sec && isLast  ? '3px solid #555' : 'none',
                                                                borderRadius: sec ? (isFirst && isLast ? '8px' : isFirst ? '8px 8px 0 0' : isLast ? '0 0 8px 8px' : '0') : '0',
                                                                marginTop:    sec && isFirst ? '14px' : undefined,
                                                            }}>
                                                            {sec && isFirst && (
                                                                <span style={{ position: 'absolute', top: '-13px', left: '34px', fontWeight: 'bold', fontSize: '0.72rem',
                                                                    background: PALETA_F[si % PALETA_F.length], padding: '0 6px', border: '2px solid #555', borderRadius: '4px' }}>
                                                                    {sec}
                                                                </span>
                                                            )}
                                                            <span disabled>
                                                                <div className="d-flex mx-1 bg-primary text-white justify-content-center align-items-center rounded-5" style={{ height: '25px', width: '25px' }}>
                                                                    <div className="d-flex justify-content-center">
                                                                        <span style={{ fontSize: '0.5em' }}>{e.fila}</span>
                                                                    </div>
                                                                </div>
                                                            </span>
                                                            <div className={'d-flex ml-3 flex-row px-1 align-items-stretch ' + (
                                                                    alineacionFilas[e.fila] === 'izquierda' ? 'justify-content-start' :
                                                                    alineacionFilas[e.fila] === 'derecha' ? 'justify-content-end' :
                                                                    'justify-content-lg-center'
                                                                )} style={{ width: '100%' }}>
                                                                {(ordenSillasFilas[e.fila] ? [...e.asientos].reverse() : e.asientos).map((silla, index) => {
                                                                    let numero = String(silla.silla).split("-")[2]
                                                                    return (
                                                                        <div key={"silla" + index} id={String(silla.idsilla ?? silla.id ?? silla.id_silla ?? ("seat-" + silla.silla))}
                                                                            className={silla.silla + '  d-flex  ' + sillasetado(silla) + '  rounded-5 sillasfila text-center  justify-content-center align-items-center'}
                                                                            style={{ height: '20px', width: '20px', marginLeft: '1px' }}
                                                                            onClick={() => Agregarsilla(silla)}>
                                                                            <div className='px-3 d-flex text-white justify-content-center'>
                                                                                <div className="d-flex justify-content-center">
                                                                                    <span style={{ fontSize: '0.5em' }}>{numero}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                : ""}
                                        </div>
                                    </div>
                                    )
                                })() : ''}

                                {modalshow.nombre == "Modallocalida" && mapath.precio.typo === "mesa" ? (() => {
                                        const seccionesUnicas = [...new Set(Object.values(secciones))].filter(Boolean)
                                        const totalFilas = mapath.localidadespecica.length
                                        return (
                                        <>
                                        <div className="d-flex justify-content-center align-items-center mb-2" style={{ gap: '8px' }}>
                                            <button
                                                className="btn btn-sm btn-outline-secondary"
                                                onClick={() => setZoomMesas(z => Math.max(0.5, +(z - 0.1).toFixed(2)))}
                                                title="Alejar mesas"
                                            >➖</button>
                                            <span className="small text-muted">{Math.round(zoomMesas * 100)}%</span>
                                            <button
                                                className="btn btn-sm btn-outline-secondary"
                                                onClick={() => setZoomMesas(z => Math.min(1.5, +(z + 0.1).toFixed(2)))}
                                                title="Acercar mesas"
                                            >➕</button>
                                        </div>
                                        <div className="col-sm-12 text-center" style={{ maxHeight: '550px', minHeight: '250px', overflowY: 'auto', overflowX: 'auto' }}>
                                            <div style={{ display: 'inline-block', transform: `scale(${zoomMesas})`, transformOrigin: 'top center', transition: 'transform 0.15s' }}>
                                            {mapath.localidadespecica.length > 0 ?
                                                mapath.localidadespecica.map((fila, fi) => {
                                                    const isFirst = fi === 0
                                                    const isLast  = fi === totalFilas - 1
                                                    // agrupar mesas consecutivas de la misma sección
                                                    const grupos = []
                                                    ordenarMesas(fila.Mesas, orden).forEach(mesa => {
                                                        const sec = secciones[mesa.mesa] || null
                                                        if (!grupos.length || grupos[grupos.length - 1].sec !== sec) {
                                                            grupos.push({ sec, mesas: [mesa] })
                                                        } else {
                                                            grupos[grupos.length - 1].mesas.push(mesa)
                                                        }
                                                    })
                                                    return (
                                                        <div className='d-flex PX-1 align-items-center' key={fi}>
                                                            <div className='d-flex pb-2'><MesasView text={fila.fila} /></div>
                                                            <div className='d-flex'>
                                                                {grupos.map((g, gi) => {
                                                                    const si = seccionesUnicas.indexOf(g.sec)
                                                                    const hasSec = g.sec !== null
                                                                    return (
                                                                        <div key={gi} className="d-flex flex-column" style={{
                                                                            background:    hasSec ? PALETA_FONDO_SEC[si % PALETA_FONDO_SEC.length] : 'transparent',
                                                                            borderLeft:    hasSec ? '2px solid #666' : 'none',
                                                                            borderRight:   hasSec ? '2px solid #666' : 'none',
                                                                            borderTop:     hasSec && isFirst ? '2px solid #666' : 'none',
                                                                            borderBottom:  hasSec && isLast  ? '2px solid #666' : 'none',
                                                                            borderRadius:  hasSec ? (isFirst && isLast ? '8px' : isFirst ? '8px 8px 0 0' : isLast ? '0 0 8px 8px' : '0') : '0',
                                                                            paddingTop:    hasSec && isFirst ? '2px' : 0,
                                                                            paddingBottom: hasSec && isLast  ? '4px' : 0,
                                                                        }}>
                                                                            {isFirst && hasSec && (
                                                                                <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '0.78rem', padding: '3px 6px 1px', whiteSpace: 'nowrap' }}>
                                                                                    {g.sec}
                                                                                </div>
                                                                            )}
                                                                            <div className="d-flex">
                                                                                {g.mesas.map((mesa, mi) => (
                                                                                    <div key={mi}><MesasView status={mesa.asientos.length} text={mesa.mesa} list={mesa.asientos} /></div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                    )
                                                }) : ''}
                                            </div>
                                        </div>
                                        </>
                                        )
                                    })() : ''}
                                {mapath.precio.typo === "correlativo" ?
                                    <div>
                                        <div className="d-flex flex-wrap justify-content-center align-items-center mt-3">
                                            {mapath?.precio?.cantidad_bloqueada ? (
                                                <div className="text-center d-flex flex-column align-items-center">
                                                    {detalle.length > 0 ? (
                                                        <button
                                                            className="btn btn-outline-danger"
                                                            disabled={disable}
                                                            onClick={restaprecio}
                                                        >
                                                            Quitar promoción x{obtenerFactorCorrelativo()}
                                                        </button>
                                                    ) : (
                                                        <button
                                                            className="btn btn-success"
                                                            disabled={disable}
                                                            onClick={agregar}
                                                        >
                                                            Seleccionar promoción x{obtenerFactorCorrelativo()}
                                                        </button>
                                                    )}
                                                    <div className="col-12 text-center mt-2">
                                                        <small className="text-muted">
                                                            <strong>Promoción:</strong> esta acción agrega o quita exactamente {obtenerFactorCorrelativo()} entradas.
                                                        </small>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="text-center d-flex justify-content-end align-items-center">
                                                    {detalle.length > 0 ? (
                                                        <button className="resta  btn-danger rounded-circle "
                                                            onClick={restaprecio}
                                                            disabled={disable}
                                                        >
                                                            <i className="fa fa-minus"></i>
                                                        </button>
                                                    ) : (
                                                        <button className="resta btn-disable border rounded-circle " disabled={true}>
                                                            <i className="fa fa-minus"></i>
                                                        </button>
                                                    )}
                                                    <hr className="mx-2" ></hr>
                                                    <button className="suma   btn-success rounded-circle"
                                                        disabled={disable}
                                                        onClick={agregar}
                                                    >
                                                        <i className="fa fa-plus"></i>
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div> : ''

                                }

                            </div>

                        </div>

                    </div>

                    {spinervi ? "" :
                        <div
                            style={{
                                display: 'none',
                                position: 'fixed',
                                top: '0',
                                left: '0',
                                width: '100%',
                                height: '100%',
                                backgroundColor: 'rgba(0,0,0,0.5)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: '1000'
                            }}
                        >

                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: '10px',
                                padding: '10px',
                            }}>
                                <Triangle
                                    height="80"
                                    width="80"
                                    color="#4fa94d"
                                    ariaLabel="triangle-loading"
                                    wrapperStyle={{}}
                                    wrapperclassName=""
                                    visible={true}
                                />
                                <h4 className='text-light'>Seleccionando ...</h4>


                            </div>
                        </div>}
                </Modal.Body>
                <Modal.Footer className="px-0 bg" >
                    <div className=" d-flex  align-items-end">

                    </div>
                    <div className=" container-fluid  text-dark  border-top justify-content-between p-3" style={{ minHeight: '50px', maxHeight: '188px', width: '100%' }} >
                        {mapath.precio.typo != "correlativo" ?
                            <div className="col-12 ">
                                {mapath.precio.typo == "mesa" ? <h5>Numero de mesas y sillas seleccionadas</h5> : <h5>Sillas y Filas Selecionadas</h5>}
                                <div className="d-flex flex-wrap" style={{ minHeight: '10px', maxHeight: '150px', overflowY: 'auto', overflowX: 'hide', }}>
                                    {
                                        seleccion.length > 0 ?
                                            seleccion.filter((e) => e.estado.toLowerCase() == "seleccionado").map((elm, id) => {
                                                return (
                                                    <li key={id} className={elm.silla + '  d-flex agregados rounded-5  bg-success justify-content-center align-items-center '}

                                                        style={{ height: '30px', width: '80px', margin: '1px' }} >
                                                        <div className={'d-flex   text-white justify-content-center  '} >
                                                            <div className="d-flex  justify-content-center text-center p-2">
                                                                <span className="mx-1" style={{ fontSize: '0.8em' }}>{elm.silla.replace("-", " ").split(" ")[0]}</span>
                                                                <span style={{ fontSize: '0.8em' }}> {elm.silla.replace("-", " ").split(" ")[1]}</span>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            }) : ''
                                    }
                                </div>
                            </div> : <div>


                            </div>}
                        <div className="px-0">
                            {mapath.precio.typo === "correlativo" ?
                                <div className="d-flex px-0  justify-content-center " >

                                    <div className="flex-row first text-center col-sm " role="cell"
                                        style={{
                                            fontWeight: 'bold'
                                        }}
                                    >Localidad</div>
                                    {/* <div className="flex-row d-none d-sm-block  text-center col-2 col-md-2">{e.fila}</div>*/}

                                    <div className="flex-row  text-center  col-5"
                                        style={{
                                            fontWeight: 'bold'
                                        }}
                                    >Total tickets </div>
                                    <div className="flex-row   text-center col-sm"
                                        style={{
                                            fontWeight: 'bold'
                                        }}
                                    >Valor </div>


                                </div>
                                : ''

                            }
                            {
                                mapath.precio.typo === "correlativo" && detalle.length > 0 ?

                                    detalle.map((e, i) => {
                                        const factorBoletos = Number(e?.localidaEspacio?.factor_boletos || e?.factor_boletos || 1)
                                        const cantidadAsientos = Number(e?.cantidad || 0)
                                        const cantidadCobro = factorBoletos > 1
                                            ? Math.ceil(cantidadAsientos / factorBoletos)
                                            : cantidadAsientos
                                        const totalLinea = parseFloat(e.valor || 0) * cantidadCobro
                                        return (
                                            <div className="d-flex  justify-content-center " role="rowgroup" key={"items" + i}>

                                                <div className="flex-row first text-center col-sm " role="cell"> {e.localidad}</div>
                                                {/* <div className="flex-row d-none d-sm-block  text-center col-2 col-md-2">{e.fila}</div>*/}

                                                <div className="flex-row  text-center  col-5"> {e.cantidad}</div>
                                                <div className="flex-row   text-center col-sm"> ${totalLinea.toFixed(2)}</div>


                                            </div>
                                        )
                                    })



                                    : ''

                            }
                            {
                                mapath.precio.typo === "correlativo" && detalle.length > 0 ? <div className="text-center ">
                                    <button className="btn btn-primary mt-2" onClick={cerrar} > Continuar </button>


                                </div> : ''}
                        </div>



                    </div>

                </Modal.Footer>

            </Modal>

        </>
    )

}

export default LocalidadmapViews